export const API_BASE_URL = process.env.NODE_ENV === 'development' ? 'http://localhost:8080/v1.0' : 'https://deepprojectv3deploy.appspot.com/v1.0';

export const API_LOGIN = `${API_BASE_URL}/user/login`;
export const API_SIGNUP = `${API_BASE_URL}/user/register`;

export const API_RESEARCH = `${API_BASE_URL}/research`;
export const API_SUBMITTED_RESEARCH = `${API_RESEARCH}/submitted`;

export const API_CATEGORY = `${API_BASE_URL}/category`;
export const API_POTENTIAL = `${API_BASE_URL}/potential`;
export const API_OFFER = `${API_BASE_URL}/offer`;
export const API_HOOK = `${API_BASE_URL}/hook`;
export const API_MOTIVATION = `${API_BASE_URL}/motivation`;
export const API_ENDGAME = `${API_BASE_URL}/endgame`;
